import apiRequest from './handler';

const EnquiryService = {
    getEnquiryOptions: async (setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/enquiry-options`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    },

    createEnquiry: async (payload, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/support/create-enquiry`,
                'post',
                payload,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error creating enquiry:', error);
            throw error;
        }
    },
};

export default EnquiryService;
